import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import _ from "lodash";

import "./index.css"

import BuyerQuoteView from "./Components/BuyerQuoteView";

import { getUserRoles, getUsers, searchUsers } from "../../services/api/user";
import { getBuyerQuoteByBuyerQuoteId } from "../../services/api/buyerQuote"
import { getBuyerRateContracts } from "../../services/api/buyerRateContracts";
import { getApprovalInstancesByDocNo } from "../../services/api/approvalInstances";
import { getSellerDetailsBybuyerReqIdForBuyerQuote } from "../../services/api/sellerReq";
import { getBuyerReqItems, getMaterialItemsDataByBuyerReqItemIds } from "../../services/api/buyerReqItem";

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchApprovalTypes, fetchApprovals, fetchHSNMasterData, fetchMaterialBrands, fetchMaterialCategories, fetchMaterialUoms, fetchStatus } from "../../services/redux/reducers/commonThunk";

import { getTempBuyerQuoteItems, round } from "../../utils";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";


const BuyerQuotationDocument = () => {
    const { buyerQuoteId } = useParams()
   
    const [visiblePageLoading, setVisiblePageLoading] = useState(false)

    const [buyerReq, setBuyerReq] = useState({})
    const [buyerReqItems, setBuyerReqItems] = useState([])
    const [sellerReqItems, setSellerReqItems] = useState([])
    const [buyerQuote, setBuyerQuote] = useState({})
    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [buyerPO, setBuyerPO] = useState([])
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [buyerRateContracts, setBuyerRateContracts] = useState([])
    const [buyerCompanyDetails, setBuyerCompanyDetails] = useState({})
    const [buyerBranchUsers, setBuyerBranchUsers] = useState([])

    const [buyerBillAddrDetails, setBuyerBillAddrDetails] = useState([])
    const [buyerShipAddrDetails, setBuyerShipAddressDetails] = useState([])
    const [buyerRelatedShipAddrs, setBuyerRelatedShipAddrs] = useState([])
    const [pmCompanyBillAddrDetails, setPmCompanyBillAddrDetails] = useState([])
    const [documentHTML, setDocumentHTML] = useState()
    const [buyerQuotePDFURL, setBuyerQuotePDFURL] = useState('')
    const [PDFDownloadLoading, setPDFDownloadLoading] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
 
    const [raisedBuyerQuoteItems, setraisedBuyerQuoteItems] = useState([])
    const [initialRaisedBuyerQuoteItems, setInitialRaisedBuyerQuoteItems] = useState([])
    const [selectedBuyerQuoteItems, setSelectedBuyerQuoteItems] = useState([])
    const [selectedBuyerBillAddrId, setSelectedBuyerBillAddrId] = useState(null)
    const [selectedBuyerShipAddrId, setSelectedBuyerShipAddrId] = useState(null)
    const [isAllItemsPODone, setIsAllItemsPODone] = useState(false) 

    const [materialDetails, setMaterialDetails] = useState([])
    const [approvalInstances, setApprovalInstances] = useState([])

    const statusData = useSelector((state) => state.common.status)
    const brandData = useSelector((state) => state.common.materialBrands)
    const approvals = useSelector((state) => state.common.approvals)
    const approvalTypes = useSelector(state => state.common.approvalTypes)
    const materialCategories = useSelector((state) => state.common.materialCategories)
    const materialUOMs = useSelector((state) => state.common.materialUOMs)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)

    const dispatch = useDispatch()

    let notItemTerms = ["courier", "logistics", "transport", "freight"]

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)

    let quotationApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => pmCompanyConfig.quotationApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])

    useEffect(()=> {
        dispatch(fetchMaterialCategories())
        dispatch(fetchApprovalTypes())
        dispatch(fetchMaterialUoms())
        dispatch(fetchApprovals())
        dispatch(fetchMaterialBrands())
        dispatch(fetchStatus())
        dispatch(fetchHSNMasterData())
    }, [])

    useEffect(() => {
        if(quotationApprovals?.length > 0 && materialCategories?.length > 0 && statusData?.length > 0 && brandData?.length > 0 && HSNMasterData?.length > 0 && materialUOMs?.length > 0){
            getBuyerQuotes()
        }
    }, [quotationApprovals, materialCategories, statusData, brandData, HSNMasterData, materialUOMs])

    const getBuyerQuotes = async () => {
        setVisiblePageLoading(true)
        const response = await getBuyerQuoteByBuyerQuoteId(buyerQuoteId)
        if (response.failure){
            dispatch(raiseToast({severity:'error', detail: response.data.error, summary:'Buyer Quotes Not Fetched', life: 3000}))
        }else {
            let buyerQuoteResponse = response?.data.buyerQuote
            let buyerQuoteItemsResponse = response?.data.buyerQuoteItems  
            let buyerPOResponse = response?.data.buyerPO
            let buyerPOItemsResponse = response?.data.buyerPOItems

            const buyerBillAddrDetailsRes = response?.data.buyerBillAddrDetails
            const pmCompanyBillAddrDetailsRes = response?.data.pmCompanyBillAddrDetails
            const buyerShipAddrDetails = response?.data.buyerShipAddrDetails
            const buyerRelatedShippingAddr = response?.data?.buyerRelatedShipAddrs?.data
            const relatedBuyerReq = response?.data?.buyerRequirement
            
            let buyerReqItemsIds = []
            let allGSTRate = []
            buyerQuoteItemsResponse?.forEach(eachBuyerQuoteItem => {
                buyerReqItemsIds.push(eachBuyerQuoteItem?.buyerReqItemId)
                if(!allGSTRate.includes(eachBuyerQuoteItem.bQuoteGSTRate)){
                    allGSTRate.push(eachBuyerQuoteItem.bQuoteGSTRate)
                }
            })
            const maxGSTRate = _.maxBy(allGSTRate)
            buyerQuoteResponse.maxLogisticGSTRate = maxGSTRate

            const materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds : buyerReqItemsIds })
            if (materialDetailsRes?.failure){
                setVisiblePageLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Material Details', detail: materialDetailsRes.data.error, life: 3000}))
            }

            const companyERPCodeMapIds = []
            materialDetailsRes?.data?.map(eachMaterial => {
                if (eachMaterial?.companyERPCodeMapId){
                    companyERPCodeMapIds.push(eachMaterial?.companyERPCodeMapId)
                }
            })
            let buyerRateContracts = []
            if (companyERPCodeMapIds.length){
                const buyerRateContractResponse = await getBuyerRateContracts({companyERPCodeMapIds: companyERPCodeMapIds, paginator: false})
                if (buyerRateContractResponse?.failure){
                    setVisiblePageLoading(false)
                    return dispatch(raiseToast({severity:'error', summary: 'Buyer Rate Contract', detail: buyerRateContractResponse.data.error, life: 3000}))
                }

                buyerRateContracts = buyerRateContractResponse.data.data
            }

            const buyerReqItemsRes = await getBuyerReqItems({buyerReqItemIds: buyerReqItemsIds})
            if(buyerReqItemsRes?.failure){
                setVisiblePageLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Buyer requirement Items', detail: buyerReqItemsRes.data.error, life: 3000}))
            }

            const updatedBuyerReqItemRes = buyerReqItemsRes?.data?.data.map(eachReqItem => {
                const relatedMaterial = materialDetailsRes?.data.find(eachMaterial => eachMaterial.materialId === eachReqItem.materialId)
                return {...eachReqItem, brandId: relatedMaterial.brandId, categoryId: relatedMaterial.categoryId}
            })

            const approvalInstanceRes = await getApprovalInstancesByDocNo({docNo: buyerQuoteResponse.docNo})
            if(approvalInstanceRes.failure){
                setVisiblePageLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Approval instances', detail: approvalInstanceRes.data.error, life: 3000}))
            }

            const sellerReqItemsResponse = await getSellerDetailsBybuyerReqIdForBuyerQuote(relatedBuyerReq.buyerReqId)

            const tempBuyerQuoteItems = getTempBuyerQuoteItems(buyerQuoteResponse, buyerReqItemsRes?.data?.data, sellerReqItemsResponse.sellerReqItems, buyerQuoteItemsResponse, materialDetailsRes?.data)


            updatedBuyerReqItemRes.map(eachBuyerReqItem => {
            
                let relatedBuyerQuoteItems = buyerQuoteItemsResponse.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId)
                let relatedTempBuyerQuoteItems = tempBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId)

                if(relatedBuyerQuoteItems.length){
                    const selectedBuyerQuoteItems = relatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerQty)

                    const bestSellerWeightedSum = _.sumBy(selectedBuyerQuoteItems, obj => obj.bQuotSellerPrice * parseFloat(obj.bQuotSellerQty))
                    const bestSellerTotalQuantity = _.sumBy(selectedBuyerQuoteItems, obj => parseFloat(obj.bQuotSellerQty))

                    const sellerWeightedAverageSellerPrice = round(bestSellerWeightedSum / bestSellerTotalQuantity, 2)

                    relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                        eachBuyerQuoteItem.avgSellerPrice = sellerWeightedAverageSellerPrice

                        const relatedTempBuyerQuoteItem = relatedTempBuyerQuoteItems.find(obj =>obj.buyerQuoteItemId === eachBuyerQuoteItem.buyerQuoteItemId)
                        eachBuyerQuoteItem.bestAvgSellerPrice = relatedTempBuyerQuoteItem?.bestAvgSellerPrice
                    })
                }
            })

            let updatedBuyerQuoteItems  = buyerQuoteItemsResponse.map(eachBuyerQuoteItem => {
                let relatedSellerReqItem = sellerReqItemsResponse.sellerReqItems.find(eachSellerReqItem => eachSellerReqItem.sellerReqItemId === eachBuyerQuoteItem.sellerReqItemId)
                return {...eachBuyerQuoteItem, "bQuotSellerGSTRate": relatedSellerReqItem.quotGSTRate}
            })

            setBuyerQuote(buyerQuoteResponse)
            setBuyerQuoteItems(updatedBuyerQuoteItems) //edit quote items res
            setSellerReqItems(sellerReqItemsResponse?.sellerReqItems)
            setBuyerPO(buyerPOResponse)
            setBuyerPOItems(buyerPOItemsResponse)
            setBuyerBillAddrDetails(buyerBillAddrDetailsRes)
            setPmCompanyBillAddrDetails(pmCompanyBillAddrDetailsRes)
            setBuyerShipAddressDetails(buyerShipAddrDetails)
            setBuyerRelatedShipAddrs(buyerRelatedShippingAddr)
            setBuyerReq(relatedBuyerReq)
            setSelectedBuyerBillAddrId(buyerQuoteResponse.billAddrId)
            setSelectedBuyerShipAddrId(relatedBuyerReq?.shipAddrId)
            setBuyerReqItems(updatedBuyerReqItemRes)  //edit req items res
            setBuyerQuotePDFURL(response?.data?.buyerQuoteDocPDFURL)
            setDocumentHTML(response?.data?.documentHTML)
            setPDFDownloadLoading(false)
            setMaterialDetails(materialDetailsRes?.data)
            setApprovalInstances(approvalInstanceRes.data)
            setBuyerCompanyDetails(response.data.buyerCompanyDetails)
            setBuyerBranchUsers(response.data.buyerBranchUsers)
            setBuyerRateContracts(buyerRateContracts)

            const newRaisedBuyerQuoteItems = []
            const buyerReqIds = [...new Set(buyerQuoteItemsResponse?.map(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId))]

            buyerReqIds.map(eachBuyerReqItemId => {
                const relatedBuyerReqQuoteItem = buyerQuoteItemsResponse?.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItemId)
                newRaisedBuyerQuoteItems.push({...relatedBuyerReqQuoteItem})
            })
            const updatedRaisedBuyerQuoteItems = newRaisedBuyerQuoteItems?.map(eachBuyerQuoteItem => {
                const relatedMaterial = materialDetailsRes?.data?.find(eachMaterial => eachMaterial?.buyerReqItemId === eachBuyerQuoteItem?.buyerReqItemId)

                let relatedUOM = null
                if (relatedMaterial?.companyERPUOM){
                    relatedUOM = materialUOMs?.find(eachUOM => eachUOM?.UOM === relatedMaterial?.companyERPUOM)
                    if (!relatedUOM){
                        // relatedUOM = relatedMaterial?.UOMValue === '1' ? relatedMaterial?.UOM : 'NOS'
                        relatedUOM = materialUOMs?.find(eachUOM => {
                            if (relatedMaterial?.UOMValue === '1'){
                                return eachUOM?.UOM === relatedMaterial?.UOM
                            }else{
                                return eachUOM?.UOM === 'NOS'
                            }
                        })
                    }
                }else{
                    relatedUOM = materialUOMs?.find(eachUOM => eachUOM?.UOM === relatedMaterial?.UOM)
                }
                let totalCompletedQty = 0
                buyerPOItemsResponse?.map(eachBuyerPOItem => {
                    if (eachBuyerPOItem?.buyerQuoteItemId === eachBuyerQuoteItem?.buyerQuoteItemId){ //need to discuss
                        totalCompletedQty += eachBuyerPOItem?.bPOQty
                    }
                })
                let availableQty = (eachBuyerQuoteItem?.totReqQty - totalCompletedQty) < 0 ? 0 : eachBuyerQuoteItem?.totReqQty - totalCompletedQty
                let companyQtyMultiplier = relatedMaterial?.companyQtyMultiplier ? relatedMaterial?.companyQtyMultiplier : 1
                return {...eachBuyerQuoteItem, bPOQty : availableQty, ... relatedMaterial, companyERPUOMId: relatedUOM?.materialUOMId, companyQtyMultiplier : companyQtyMultiplier, isEditable: false }
            })
            let allPODone = updatedRaisedBuyerQuoteItems?.every(eachBuyerQuoteItem => eachBuyerQuoteItem?.bPOQty === 0)

            let buyerQuoteItemIds = []
            updatedRaisedBuyerQuoteItems.map(eachBuyerPOItem => {
                if(allPODone){
                    buyerQuoteItemIds.push(eachBuyerPOItem?.buyerQuoteItemId)
                }else{
                    if (eachBuyerPOItem?.bPOQty !== 0){
                        buyerQuoteItemIds.push(eachBuyerPOItem.buyerQuoteItemId)
                    }
                }
            })


            let isAllAreNotProducts = updatedRaisedBuyerQuoteItems?.some(eachBuyerQuoteItem => {
                const relatedMaterial = materialDetailsRes?.data?.find(eachMaterial => eachMaterial?.materialId === eachBuyerQuoteItem?.materialId)
                let productName = relatedMaterial?.companyProdName ? relatedMaterial?.companyProdName : relatedMaterial?.productName
                let productSpecification = relatedMaterial?.companyProdName ? relatedMaterial?.companyProdName : relatedMaterial?.productName
                let isProductIncluded = notItemTerms.includes(productName.toLowerCase()) || notItemTerms.includes(productSpecification.toLowerCase())
                return isProductIncluded
            })
            if (isAllAreNotProducts){
                dispatch(raiseToast({severity:'warn', detail: "Shipping/Logistics Charges are included as products", life: 20000}))
            }

            setIsAllItemsPODone(allPODone)
            setraisedBuyerQuoteItems(updatedRaisedBuyerQuoteItems)
            setInitialRaisedBuyerQuoteItems(updatedRaisedBuyerQuoteItems)
            setSelectedBuyerQuoteItems(buyerQuoteItemIds)
        }
        setVisiblePageLoading(false)
    }

    return (
        <>
            <div style={{ display: "flex", flexDirection: "column",lineHeight: "1.5", height: "auto"}} className="buyer-po-doc pb-3 md:align-items-center">
                <BuyerQuoteView 
                    buyerQuoteId={buyerQuoteId}
                    buyerQuote={buyerQuote}
                    setBuyerQuote={setBuyerQuote}
                    buyerQuoteItems={buyerQuoteItems}
                    buyerReq={buyerReq}
                    buyerReqItems={buyerReqItems}
                    buyerPO={buyerPO}
                    buyerPOItems={buyerPOItems}
                    sellerReqItems={sellerReqItems}
                    buyerRateContracts={buyerRateContracts}
                    materialDetails={materialDetails}
                    buyerBillAddrDetails={buyerBillAddrDetails}
                    buyerShipAddrDetails={buyerShipAddrDetails}
                    setBuyerShipAddressDetails={setBuyerShipAddressDetails}
                    pmCompanyBillAddrDetails={pmCompanyBillAddrDetails}
                    getBuyerQuotes={getBuyerQuotes}
                    approvalInstances={approvalInstances}
                    setApprovalInstances={setApprovalInstances}
                    isAllItemsPODone={isAllItemsPODone}
                    raisedBuyerQuoteItems={raisedBuyerQuoteItems}
                    setraisedBuyerQuoteItems={setraisedBuyerQuoteItems}
                    selectedBuyerQuoteItems={selectedBuyerQuoteItems}
                    setSelectedBuyerQuoteItems={setSelectedBuyerQuoteItems}
                    initialRaisedBuyerQuoteItems={initialRaisedBuyerQuoteItems}
                    selectedBuyerBillAddrId={selectedBuyerBillAddrId}
                    setSelectedBuyerBillAddrId={setSelectedBuyerBillAddrId}
                    selectedBuyerShipAddrId={selectedBuyerShipAddrId}
                    setSelectedBuyerShipAddrId={setSelectedBuyerShipAddrId}
                    documentHTML={documentHTML}
                    buyerQuotePDFURL={buyerQuotePDFURL}
                    setBuyerQuotePDFURL={setBuyerQuotePDFURL}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    visiblePageLoading={visiblePageLoading}
                    setVisiblePageLoading={setVisiblePageLoading}
                    buyerBranchUsers={buyerBranchUsers}
                    buyerCompanyDetails={buyerCompanyDetails}
                />
            </div>
        </>
    )
}

export default BuyerQuotationDocument